import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { DocubirdCache, OneNoteProgId, SharePointFolderContentTypeIds } from "../../../src/taskpane/config/constants";
import { RootState } from "../../../src/taskpane/redux";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { getValidHooks } from "../../../src/taskpane/services/HooksService";
import { CacheHelper } from "../../../utilities/CacheHelper";
import { HookType } from "../../../src/taskpane/components/_v2/redux/api/local/api-local-interfaces";

export function useMenuItem_Automation(selectedItems: any[], waitFor: boolean, setApprovalFiles: (approvalFiles: any[]) => void, setIsApprovalsPanelOpen: (isApprovalsPanelOpen: boolean) => void) {
    const languageStrings = React.useContext(LanguageContext);

    const tenantEnableApprovalHooks = useSelector((state: RootState) => state.user.tenantEnableApprovalHooks);
    const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.length > 0 ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1] : null);

    const [automationFlowsAvailable, setAutomationFlowsAvailable] = React.useState(false);
    const [menuItem_Automation, setMenuItem_Automation] = React.useState<IContextualMenuItem>();

    React.useEffect(() => {
        if (!tenantEnableApprovalHooks || !currentDirectory?.siteDisplayName || (!currentDirectory?.DocumentLibrary && !currentDirectory.sharepointList)) return;
        const validHooks = getValidHooks(CacheHelper.get(DocubirdCache.hooks)?.filter(h => h.typeId === HookType.Approval || h.typeId === HookType.BatchApproval || h.typeId === HookType.Generic), currentDirectory);
        setAutomationFlowsAvailable(validHooks?.length > 0);
    }, [tenantEnableApprovalHooks, currentDirectory]);

    React.useEffect(() => {
        const hasFolderOrOneNoteFolder = selectedItems?.some(x => x.ContentTypeId?.startsWith(SharePointFolderContentTypeIds.folder)) || selectedItems?.some(x => x.ProgId === OneNoteProgId);
        if (selectedItems.length > 0
            && tenantEnableApprovalHooks
            && !hasFolderOrOneNoteFolder
            // && currentDirectory.type !== ComponentTypes.SharePointList
            && automationFlowsAvailable) {
            setMenuItem_Automation(
                {
                    key: "approvalHooks",
                    disabled: waitFor === true,
                    text: languageStrings.Automation,
                    iconProps: { iconName: "DocumentApproval" },
                    onClick: () => {
                        setApprovalFiles(selectedItems);
                        setIsApprovalsPanelOpen(true);
                    }
                }
            )
        } else {
            setMenuItem_Automation(null);
        }
    }, [selectedItems, waitFor, tenantEnableApprovalHooks, currentDirectory, automationFlowsAvailable])

    return {
        menuItem_Automation
    }

}